module.exports = __webpack_public_path__ + "img/icon-sleep-time-3.adfbaefd.svg";